<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="flex flex-col items-center mb-6">
      <div class="px-4 mb-6">
        <img
          alt="..."
          class="shadow rounded max-w-full h-auto align-middle border-none"
          :src="input.avatar?input.avatar:imgPlaceholder"
          style="width: 150px;"
        />
      </div>
      <div class="flex flex-col mb-2" v-if="isErrorImage">
        <text-error v-if="isErrorImage" text="Image is required" />
      </div>
      <div class="flex">
        <Button label="Browse File" v-if="!input.avatar">
          <template v-slot:any>
            <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                   type="file"
                   name="profile_picture"
                   @change="onFileChange"
            />
          </template>
        </Button>
        <Button label="Cancel" variant="default" v-if="input.avatar" @clicked="changeImage"></Button>
      </div>
    </div>
    <div class="flex gap-6">
      <div class="flex w-1/2 flex-col">
        <form-item label='Full Name'>
          <template v-slot>
            <Input
              v-model="input.name"
              placeholder="Full Name"
              :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
              maxlength="100"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill your name." />
              <text-error v-if="$v.input.name.$dirty && !$v.input.name.maxLength" text="Max length Video name is 100 character." />
            </div>
          </template>
        </form-item>
        <form-item label='Email'>
          <template v-slot>
            <Input
              v-model="input.email"
              placeholder="Email"
              :error="isErrorEmail"
              maxlength="100"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.input.email.$dirty && !$v.input.email.required" text="Please fill your email." />
              <text-error v-if="$v.input.email.$dirty && !$v.input.email.email" text="Please fill your correct email." />
              <text-error v-if="$v.input.email.$dirty && !$v.input.email.maxLength" text="Max length Video name is 100 character." />
              <text-error v-if="emailErrorMessage.length > 0" :text="emailErrorMessage" />
            </div>
          </template>
        </form-item>
        <form-item label='Birthdate' v-if="isArtist">
          <template v-slot>
            <Input
              type="date"
              v-model="input.dob"
              placeholder="Birthdate"
              :error="$v.input.dob.$dirty && !$v.input.dob.required"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.input.dob.$dirty && !$v.input.dob.required" text="Please fill your birthdate." />
            </div>
          </template>
        </form-item>
        <form-item label='Bio' v-if="isArtist">
          <template v-slot>
            <div class="relative" >
                <TextArea
                  v-model="input.bio"
                  placeholder="Tell us about you"
                  :error="$v.input.bio.$dirty && !$v.input.bio.maxLength"
                  maxlength="2000"
                  rows="10"
                />
              <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{input.bio.length}}/2000</div>
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.input.bio.$dirty && !$v.input.bio.maxLength" text="Maximum character for bio is 2000 characters." />
            </div>
          </template>
        </form-item>
      </div>
      <div class="flex w-1/2 flex-col">
        <form-item label='Bank Name' v-if="isArtist">
          <template v-slot>
            <Input
              v-model="input.bank.bank"
              placeholder="Bank Name"
            />
          </template>
        </form-item>
        <form-item label='Account Name' v-if="isArtist">
          <template v-slot>
            <Input
              v-model="input.bank.account_name"
              placeholder="Account Name"
            />
          </template>
        </form-item>
        <form-item label='Account Number' v-if="isArtist">
          <template v-slot>
            <Input
              v-model="input.bank.account_number"
              placeholder="Account Number"
            />
          </template>
        </form-item>
        <form-item label='Swift Code' v-if="isArtist">
          <template v-slot>
            <Input
              v-model="input.bank.swift_code"
              placeholder="Swift Code"
            />
          </template>
        </form-item>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

export default {
  name: 'EditProfile',
  mixins: [validationMixin],
  data: () => ({
    input: {
      name: '',
      email: '',
      dob: '',
      bio: '',
      avatar: '',
      bank: {
        bank: '',
        account_name: '',
        account_number: '',
        swift_code: '',
      },
    },
    isEmailExist: false,
    imgPlaceholder,
  }),
  validations() {
    let rule = {
      input: {
        name: {

        },
        email: {

        },
        bio: {

        },
        dob: {

        },
      },
    };
    if (this.isArtist) {
      rule = {
        input: {
          name: {
            required,
            maxLength: maxLength(100),
          },
          email: {
            required,
            email,
            maxLength: maxLength(100),
          },
          bio: {
            maxLength: maxLength(2000),
          },
          dob: {
            required,
          },
        },
      };
    } else {
      rule = {
        input: {
          name: {
            required,
            maxLength: maxLength(100),
          },
          email: {
            required,
            email,
            maxLength: maxLength(100),
          },
        },
      };
    }
    return rule;
  },
  props: {
    user: {
      type: Object,
      default: () => ({
        name: '',
        email: '',
        dob: '',
        bio: '',
        avatar: '',
        bank: {
          bank: '',
          account_name: '',
          account_number: '',
          swift_code: '',
        },
      }),
    },
    emailErrorMessage: {
      type: String,
      default: '',
    },
    imageErrorMessage: {
      type: String,
      default: '',
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(user) {
        this.input = Object.assign(this.input, user);
        this.input.bio = this.input.bio_status == 1 ? (this.input.biodata || '') : this.input.bio;
      },
    },
    input: {
      immediate: true,
      deep: true,
      handler(input) {
        this.$emit('save', input);
      },
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isAdmin', 'isFinance', 'isSuperAdmin', 'isOps', 'isArtist', 'isReviewer', 'isReviewer']),
    isErrorEmail() {
      return (this.$v.input.email.$dirty && !this.$v.input.email.required)
            || (this.$v.input.email.$dirty && !this.$v.input.email.email)
            || (this.$v.input.email.$dirty && !this.$v.input.email.maxLength)
            || (this.emailErrorMessage.length > 0);
    },
    isErrorImage() {
      return this.imageErrorMessage.length > 0;
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.input.avatar = URL.createObjectURL(file);
    },
    changeImage() {
      this.input.avatar = null;
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/EditProfile.vue